<template>
  <div class="signup-step">
    <span class="eyebrow">{{ t('step2_eyebrow') }}</span>
    <h2>
      {{ t('step2_title_prefix') }}<span class="grad">{{ t('step2_title_grad') }}</span
      >{{ t('step2_title_suffix') }}
    </h2>
    <p class="sub">{{ t('step2_sub') }}</p>

    <LocationAutocomplete
      :value="locationId"
      :label="locationLabel"
      :input-label="t('lbl_location')"
      :placeholder="t('ph_location')"
      :helper="t('loc_helper')"
      :selected-helper="selectedHelper"
      :no-results-text="t('loc_no_results')"
      @input="$emit('update:locationId', $event)"
      @update:label="$emit('update:locationLabel', $event)"
    />
  </div>
</template>

<script>
import { i18nMixin } from '../helpers';
import LocationAutocomplete from './LocationAutocomplete.vue';

export default {
  name: 'LocationStep',
  mixins: [i18nMixin],
  components: {
    LocationAutocomplete,
  },
  props: {
    locationId: { type: [Number, String], default: null },
    locationLabel: { type: String, default: '' },
  },
  computed: {
    // Resolve the picked location from the shared catalog (same source the
    // autocomplete filters) so the confirmation line shows city + PLZ whether
    // the value came from a fresh pick or a prefilled session.
    selectedLocation() {
      if (!this.locationId) {
        return null;
      }
      const all = (this.$store && this.$store.getters['locations/getLocations']) || [];
      return all.find((loc) => String(loc.id) === String(this.locationId)) || null;
    },
    // "Ausgewählt: Berlin (PLZ 10115)" — rendered in the autocomplete's helper
    // slot, so it inherits the exact same styling as `loc_helper`.
    selectedHelper() {
      const loc = this.selectedLocation;
      if (!loc) {
        return '';
      }
      return this.t('loc_selected')
        .replace(':city', loc.city)
        .replace(':id', String(loc.zip_code));
    },
  },
};
</script>
